import React from 'react';
import './LandingModal.css'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';
import { liveServerUrl } from '../../../../Shared/constant';

const LandingModal = ({ handleClose, handleShow, show }) => {

    const notify = () => toast("Wow so easy!");
    const [pageTitle, setPageTitle] = useState('')
    const [pageTags, setPageTags] = useState('')
    const [pageCatg, setPageCatg] = useState('')
    const [pageLink, setPageLink] = useState('')

    const handlePageTitle = (e) => {
        setPageTitle(e.target.value)
    }
    const handlePageTags = (e) => {
        setPageTags(e.target.value)
    }
    const handlePageCatg = (e) => {
        setPageCatg(e.target.value)
    }
    const handlePageLink = (e) => {
        setPageLink(e.target.value)
    }


    const landingPagesCont = {
        'pageName': pageTitle,
        'tags': pageTags,
        'category': pageCatg,
        'link': pageLink

    }

    const navigate = useNavigate();

    const submitLandingPage = async () => {

        const res = await fetch(`${liveServerUrl}/api/landingPages`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(landingPagesCont)
        }
        );
        const data = await res.json();
        console.log(data.success)
        if (data.success) {
            toast('Added successfully')

        }
        else {
            toast('oopps, sorry not ok')
        }

    }



    return (
        <div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton style={{ backgroundColor: '#291C3E', color: 'white' }}>
                    <Modal.Title >Upload Landing Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className='modalBody'>
                        <label htmlFor="">Page Title:</label>
                        <input type="text" placeholder='Enter page title' onChange={handlePageTitle} />
                        <label htmlFor="">Tags</label>
                        <input type="text" onChange={handlePageTags} />
                        <label htmlFor="">category</label>
                        <input type="text" onChange={handlePageCatg} />
                        <label htmlFor="">page link</label>
                        <input type="text" onChange={handlePageLink} />
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button style={{ backgroundColor: '#291C3E' }} onClick={handleClose}>
                        Close
                    </Button>
                    <Button style={{ backgroundColor: '#291C3E' }} onClick={submitLandingPage} >
                        Add to landing page
                    </Button>
                    <ToastContainer />
                </Modal.Footer>
            </Modal>


        </div>
    );
};

export default LandingModal;